import { render } from "./Article.vue?vue&type=template&id=637bbde9"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/article/Article.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "637bbde9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('637bbde9', __exports__)) {
    api.reload('637bbde9', __exports__)
  }
  
  module.hot.accept("./Article.vue?vue&type=template&id=637bbde9", () => {
    api.rerender('637bbde9', render)
  })

}


export default __exports__